export default __webpack_public_path__ + "static/media/Alatin-ban.6da88f38.jpg";